import React from 'react';
import PropTypes from 'prop-types';
import {Context} from "../Repository";

export default class Trigger extends React.Component {

  static contextType = Context;

  get repository() {
    return this.context;
  }

  get name() {
    return this.props.name;
  }

  get children() {
    return React.Children.toArray(this.props.children);
  }
  
  get trigger() {
    return this.props.trigger;
  }

  handleClick() {
    if (this.repository) {
      this.repository[this.trigger](this.name);
    }
  }

  render() {
    if (this.children.length === 0) return null;

    return (
      <React.Fragment>
        {this.children.map((child, index) => {
          return React.cloneElement(child, {
            key:     index,
            onClick: this.handleClick.bind(this)
          });
        })}
      </React.Fragment>
    );
  }
}

Trigger.OPEN = 'open';
Trigger.CLOSE = 'close';

Trigger.propTypes = {
  children: PropTypes.node.isRequired,
  trigger:  PropTypes.oneOf([Trigger.OPEN, Trigger.CLOSE]),
  name:     PropTypes.string.isRequired,
};

Trigger.defaultProps = {
  trigger: Trigger.OPEN,
};
